module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.ttf?c5907e65e838dc9f31cf7a99d5f14908";